import {ref} from "vue";
import {textWithVariables} from "../VueComponents/Suggestion.vue";
import cloneDeepWith from "lodash.clonedeepwith";

/**
 * @typedef {Object} deficiency
 * @property {string} text
 */

/**
 * @typedef {Object} examination
 * @property {deficiency} deficiency
 * @property {Object} variables
 * @property {array} images
 * @property {string|undefined} number
 * @property {string|undefined} documentation
 * @property {bool|undefined} maintenance
 */

/**
 * @returns {examination}
 */
function examinationCreate() {
    return ref({
        deficiency: {
            text: '',
        },
        variables: {},
        images: [],
        danger: {},
        number: undefined,
        documentation: undefined,
        maintenance: undefined,
        uuid: crypto.randomUUID(),
    }).value;
}

function getExaminationContent(examination) {
    return `${examination.circuitExamination ? 'Verteiler' : 'Raum'}-Mangel ${textWithVariables(examination.deficiency.text, examination.variables)}`;
}

function examinationToExaminationTemplate(examination) {
    return {
        fromExamination: true,
        categoryPath: [{name: "9999 Lokale Beobachtung"}],
        number: '',
        description: examination.deficiency.text,
        variables: cloneDeepWith(examination.variables),
        fireDanger: examination.danger.fire,
        personDanger: examination.danger.person,
        thermal: examination.thermal,
        documentation: examination.documentation,
        maintenance: examination.maintenance,
    };
}

export {
    examinationCreate,
    examinationToExaminationTemplate,
    getExaminationContent
};
